/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const log_out = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.224 13.134a.933.933 0 0 1-.933.933m0-11.2a.934.934 0 0 1 .933.933m1.91 6.533L15 8.466 13.133 6.6M15 8.466h-4.5m-5.733-.699a.233.233 0 1 0 .233.23.233.233 0 0 0-.233-.232M7 14.995l-5.6-.8a.466.466 0 0 1-.4-.462V2.85a.467.467 0 0 1 .369-.457l5.6-1.382a.467.467 0 0 1 .564.457v13.067a.467.467 0 0 1-.532.461Z"
    />
  </svg>
)
export default log_out
